import { render } from "./PeripheralMetrics.vue?vue&type=template&id=22d2d427&ts=true"
import script from "./PeripheralMetrics.vue?vue&type=script&lang=ts"
export * from "./PeripheralMetrics.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/PeripheralMetrics.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "22d2d427"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('22d2d427', __exports__)) {
    api.reload('22d2d427', __exports__)
  }
  
  module.hot.accept("./PeripheralMetrics.vue?vue&type=template&id=22d2d427&ts=true", () => {
    api.rerender('22d2d427', render)
  })

}


export default __exports__